import { render } from "./tierRisks.vue?vue&type=template&id=65953968&scoped=true&ts=true"
import script from "./tierRisks.vue?vue&type=script&lang=ts"
export * from "./tierRisks.vue?vue&type=script&lang=ts"

import "./tierRisks.vue?vue&type=style&index=0&id=65953968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65953968"]])

export default __exports__